module.exports = __webpack_public_path__ + "static/media/navidad.6a6f1f58.jpg";